import Divider from 'components/Luxkit/Divider'
import ListItem from 'components/Luxkit/List/ListItem'
import RadioButton from 'components/Luxkit/Radio/RadioButton'
import React, { useCallback } from 'react'
import { SelectedTrip } from './TripPlannerToggle'
import { BasicTrip } from 'tripPlanner/types/common'
import { TRIP_PLANNER_ALL_TRIPS_OPTION, TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION } from '../SearchResultsMap'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import noop from 'lib/function/noop'

interface Props {
  trips: Array<BasicTrip>
  selectedTrip: SelectedTrip
  handleSelectTrip?: (tripName: string, tripId?: string) => void
}

function TripList({ trips, selectedTrip, handleSelectTrip = noop }: Props) {
  const modalElement = useModalElementContext()

  const handleSelectAllTrips = useCallback(() => {
    handleSelectTrip(TRIP_PLANNER_ALL_TRIPS_OPTION)
    modalElement?.resolve()
  }, [handleSelectTrip, modalElement])

  const handleHideAllTrips = useCallback(() => {
    handleSelectTrip(TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION)
    modalElement?.resolve()
  }, [handleSelectTrip, modalElement])

  const selectTrip = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    const tripId = e.currentTarget.dataset.tripId
    const tripName = e.currentTarget.dataset.tripName!
    handleSelectTrip(tripName, tripId)
    modalElement?.resolve()
  }, [handleSelectTrip, modalElement])

  return (
    <>
      <ListItem
        title="Show all trips"
        selected={selectedTrip.name === TRIP_PLANNER_ALL_TRIPS_OPTION && !selectedTrip.tripId}
        onClick={handleSelectAllTrips}
        endIcon={<RadioButton checked={selectedTrip.name === TRIP_PLANNER_ALL_TRIPS_OPTION && !selectedTrip.tripId}/>}
      />
      <ListItem
        title="Hide all trips"
        selected={selectedTrip.name === TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION && !selectedTrip.tripId}
        onClick={handleHideAllTrips}
        endIcon={<RadioButton checked={selectedTrip.name === TRIP_PLANNER_HIDE_ALL_TRIPS_OPTION && !selectedTrip.tripId}/>}
      />
      <Divider kind="primary"/>
      {
        trips.map((trip) => {
          return (
            <ListItem
              key={trip.id}
              title={trip.name}
              selected={selectedTrip.tripId === trip.id}
              data-trip-name={trip.name}
              data-trip-id={trip.id}
              onClick={selectTrip}
              endIcon={<RadioButton checked={selectedTrip.tripId === trip.id}/>}
            />
          )
        })
      }
    </>
  )
}

export default TripList
